module.exports = __webpack_public_path__ + "static/media/value_proposition_web.b8c462ad.svg";